import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { BackArrowIcon } from "../../assets/icons";
import { routes } from "../../helpers/constants";
import Loader from "../../components/Loader";
import {
  reqToGetStaffDetails,
  reqToUpdateStaff,
} from "../../redux/slices.js/staff/staffSlice";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is Required!"),
  name: Yup.string().required("Name is Required!"),
});

const EditStaff = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const staffDetails = useSelector((state) => state.staff.staffDetails);
  const loader = useSelector((state) => state.staff.loader);

  useEffect(() => {
    dispatch(
      reqToGetStaffDetails({
        id: Number(id),
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  }, [id, dispatch]);

  const initialValues = {
    email: staffDetails.email || "",
    name: staffDetails.name || "",
  };

  const handleSubmit = (values) => {
    dispatch(
      reqToUpdateStaff({
        id: Number(id),
        data: {
          email: values.email,
          name: values.name,
          action : "edit_info",
        },
        onSuccess: () => navigate(routes.staff),
        onFailure: () => {},
      })
    );
  };

  return (
    <>
      {loader && <Loader />}
      <div className="rounded-md border-[1px] border-solid border-[#F3EFEF] sm:pb-6 h-full">
        <div className="p-3 sm:p-6 bg-[#F5FFBD] space-y-6">
          <div className="mb-4">
            <button
              type="button"
              className="text-[16px] font-normal flex gap-1"
              onClick={() => navigate(-1)}
            >
              {BackArrowIcon} Back
            </button>
          </div>
          <div className="heading flex gap-2 justify-between items-end">
            <div className="heading-title space-y-1">
              <h1 className="text-h2 !font-medium mb-0 text-[#4285F4]">
                Edit Staff Member
              </h1>
              <p className="text-span text-dark mb-0">
                Update staff member information and details
              </p>
            </div>
          </div>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values, isSubmitting }) => (
            <Form className="p-3 pt-6 sm:p-6 comman-form h-[calc(100%-185px)] flex flex-col overflow-y-auto scroll-none">
              <div className="bg-white space-y-7">
                <h2 className="text-h4 text-blue">Staff Information</h2>

                <div className="grid md:grid-cols-2 gap-6">
                  <div className="form-group">
                    <label>Name</label>
                    <Field
                      name="name"
                      placeholder="Enter full name"
                      className="w-full"
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email</label>
                    <Field
                      name="email"
                      type="email"
                      placeholder="Enter email address"
                      className="w-full"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>
              </div>

              <div className="mt-auto flex gap-3 pt-6 justify-end flex-wrap">
                <button
                  type="button"
                  className="previous-btn"
                  onClick={() => navigate(-1)}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="next-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update Staff"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default EditStaff;